export function cachedFetch({ maxAge, init, read }) {
  const requests = new Map()

  return (url) => {
    const cached = requests.get(url)
    if (cached && Date.now() - cached.requestedAt < maxAge) return cached.request

    const request = fetch(url, init).then(response => {
      if (!response.ok || response.redirected) throw new Error(`Request to ${url} failed with ${response.status}`)
      return read(response)
    })
    requests.set(url, { request, requestedAt: Date.now() })
    request.catch(() => {
      if (requests.get(url)?.request === request) requests.delete(url)
    })
    return request
  }
}
